import { func, shape } from 'prop-types';

export default shape({
    colorFamilies: shape({
        getFamilies: func,
        getFamilyColorByName: func,
        getFamilyNameByColor: func,
        doesColorExist: func,
    }),
});
